namespace SorAraBul.Membership {
    export interface SignUpForm {
        UserType: Serenity.RadioButtonEditor;
        DisplayName: Serenity.StringEditor;
        Email: Serenity.EmailAddressEditor;
        MobilePhoneNumber: Common.PhoneEditor;
        Password: Serenity.PasswordEditor;
        ConfirmPassword: Serenity.PasswordEditor;
        CompanyName: Serenity.StringEditor;
        TaxOffice: Serenity.StringEditor;
        TaxNumber: Serenity.StringEditor;
        AddressDetail: Serenity.TextAreaEditor;
        CityId: Serenity.ServiceLookupEditor;
        IlceId: Serenity.ServiceLookupEditor;
        ContactNumber: Common.PhoneEditor;
        PostalCode: Serenity.StringEditor;
    }

    export class SignUpForm extends Serenity.PrefixedContext {
        static formKey = 'Membership.SignUp';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SignUpForm.init)  {
                SignUpForm.init = true;

                var s = Serenity;
                var w0 = s.RadioButtonEditor;
                var w1 = s.StringEditor;
                var w2 = s.EmailAddressEditor;
                var w3 = Common.PhoneEditor;
                var w4 = s.PasswordEditor;
                var w5 = s.TextAreaEditor;
                var w6 = s.ServiceLookupEditor;

                Q.initFormType(SignUpForm, [
                    'UserType', w0,
                    'DisplayName', w1,
                    'Email', w2,
                    'MobilePhoneNumber', w3,
                    'Password', w4,
                    'ConfirmPassword', w4,
                    'CompanyName', w1,
                    'TaxOffice', w1,
                    'TaxNumber', w1,
                    'AddressDetail', w5,
                    'CityId', w6,
                    'IlceId', w6,
                    'ContactNumber', w3,
                    'PostalCode', w1
                ]);
            }
        }
    }
}
